module.exports = __webpack_public_path__ + "static/img/m_8.f3370226.jpg";